import { render, staticRenderFns } from "./ChannelBalanceAdjustOrder.vue?vue&type=template&id=121ff2b0&"
import script from "./ChannelBalanceAdjustOrder.vue?vue&type=script&lang=ts&"
export * from "./ChannelBalanceAdjustOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelBalanceAdjustOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelBalanceAdjustOrder.vue"
export default component.exports